import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-4 px-4 sm:px-6 bg-brand-violet" data-id="element-63" data-mp="1o3x1pk7r0m0y">
      <div className="bg-white border-2 border-brand-gold p-3.5 rounded-lg text-center shadow-md" data-id="element-64" data-mp="1o5q1qgnuw7zz">
        <p className="text-[11px] font-heading font-bold text-brand-magenta uppercase tracking-widest" data-id="element-65" data-mp="221by58wf5u2f">
          Votre achat est entièrement protégé
        </p>
        <div className="w-11 h-11 mx-auto bg-brand-pink rounded-full flex items-center justify-center mt-1.5" data-id="element-66" data-mp="19fsi8e0vg6h4">
          <ShieldCheckIcon className="w-6 h-6 text-brand-violet" data-id="element-67" data-mp="14gz88vksmxlp" />
        </div>
        <h3 className="font-display text-2xl sm:text-3xl tracking-wide text-brand-violet leading-none mt-1.5 uppercase" data-id="element-68" data-mp="1j4u24fajf80d">
          🛡️ Garantie satisfait ou remboursé pendant 7 jours
        </h3>
        <p className="text-xs sm:text-sm text-brand-slate font-medium leading-snug mt-1.5" data-id="element-69" data-mp="qnhkszozl0qe">
          Essayez GYM RYTHMIQUE PRO™ pendant 7 jours. Découvrez les 6 modules, les 5 Bonus Premium et commencez
          immédiatement à utiliser toutes les ressources avec vos gymnastes. Si vous n&apos;êtes pas entièrement
          satisfait, contactez-nous dans les 7 jours suivant votre achat et nous vous rembourserons 100 % de votre
          commande. Aucun risque. Aucune justification.
        </p>
      </div>
    </section>;
}